import { render, staticRenderFns } from "./_changePasswordCard.vue?vue&type=template&id=0ebe2872"
import script from "./_changePasswordCard.vue?vue&type=script&lang=js"
export * from "./_changePasswordCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports